"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preprocessEARanges = preprocessEARanges;
const mf_parser_1 = require("mf-parser");
function preprocessEARanges(ranges, targetEA) {
    ranges = structuredClone(ranges);
    if (typeof ranges === 'string') {
        // need to convert to ranges
        let parsed = (0, mf_parser_1.parse)(ranges.replaceAll(/[\t\n\r ]/g, ''));
        let newRanges = [];
        let current = {
            mf: '',
            min: 1,
            max: 1,
        };
        // example ClBr2(CH2)0-2NO
        // the idea is that has long as we don't have a range we don't really care
        // there is a limitation is that the range has to be first level of parenthesis
        let parenthesisLevel = 0;
        let currentMF = ''; // start at an atom first level or a parenthesis
        for (let item of parsed) {
            switch (item.kind) {
                case mf_parser_1.Kind.ATOM:
                    if (parenthesisLevel === 0 && currentMF) {
                        current.mf += currentMF;
                        currentMF = '';
                    }
                    currentMF += item.value;
                    break;
                case mf_parser_1.Kind.ISOTOPE:
                    if (parenthesisLevel === 0 && currentMF) {
                        current.mf += currentMF;
                        currentMF = '';
                    }
                    currentMF += `[${item.value.isotope}${item.value.atom}]`;
                    break;
                case mf_parser_1.Kind.MULTIPLIER:
                    if (parenthesisLevel === 0 && currentMF) {
                        current.mf += currentMF + item.value;
                        currentMF = '';
                    }
                    else {
                        currentMF += item.value;
                    }
                    break;
                case mf_parser_1.Kind.MULTIPLIER_RANGE:
                    if (parenthesisLevel !== 0) {
                        throw new Error('Range multiplier can only be at the first level');
                    }
                    newRanges.push({
                        mf: currentMF,
                        min: item.value.from,
                        max: item.value.to,
                    });
                    currentMF = '';
                    break;
                case mf_parser_1.Kind.OPENING_PARENTHESIS:
                    parenthesisLevel++;
                    currentMF += '(';
                    break;
                case mf_parser_1.Kind.CLOSING_PARENTHESIS:
                    parenthesisLevel--;
                    currentMF += ')';
                    break;
                default:
                    throw new Error(`can not preprocess ${ranges}`);
            }
        }
        if (currentMF) {
            current.mf += currentMF;
        }
        if (current.mf) {
            newRanges.push(current);
        }
        ranges = newRanges;
    }
    let possibilities = [];
    for (let i = 0; i < ranges.length; i++) {
        let range = ranges[i];
        let min = range.min === undefined ? 0 : range.min;
        let max = range.max === undefined ? 1 : range.max;
        let possibility = {
            mf: range.mf,
            minCount: min, // value defined by the user
            maxCount: max, // value defined by the user
            targetEA: targetEA[range.mf],
            mw: 0, // mw till this level
            aw: 0, // atomic weight (mass * currentCount)
            maxRatio: 0, // maximum ratio possible if all next elements are 0
            currentValue: 0,
            currentCount: min - 1,
            currentUnsaturation: 0,
            initialOrder: i,
        };
        possibilities.push(possibility);
        let info = new mf_parser_1.MF(range.mf).getInfo();
        possibility.mass = info.mass;
        possibility.unsaturation =
            range.unsaturation === undefined
                ? (info.unsaturation - 1) * 2
                : range.unsaturation;
        if (possibility.mf !== info.mf)
            possibility.isGroup = true;
    }
    possibilities = possibilities.filter((r) => r.minCount !== 0 || r.maxCount !== 0);
    possibilities.sort((a, b) => {
        return b.targetEA - a.targetEA;
    });
    return possibilities;
}
//# sourceMappingURL=preprocessEARanges.js.map